import libs from '../../libs'

const state = {
  geoWPP: null,
  geoPortzone: null,
  settingPortsDefault: [],
  settingPortsActive: {},
  settingPortsEnable: false
}

const getters = {
  geoWPP: (state) => state.geoWPP,
  geoPortzone: (state) => state.geoPortzone,
  settingPortsDefault: (state) => state.settingPortsDefault,
  settingPortsActive: (state) => state.settingPortsActive
}

const actions = {
  toLoadGeoWPP: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat data wpp')

    let geoWPP = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/geo/wpp`
    })

    if (geoWPP) {
      commit('setGeoWPP', geoWPP.data.wpp)
    }

    commit('unsetLoading')
  },
  toLoadGeoPorts: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat data pelabuhan')

    const geoPorts = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/geo/ports`
    })

    if (geoPorts) {
      commit('setGeoPortzone', geoPorts.data.ports)
    }

    commit('unsetLoading')
  },
  toLoadSettingPorts: async function ({ commit }, query) {
    commit('setLoading', 'memuat data pelabuhan')

    const newQuery = libs.generateQuery(query)
    const portzone = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/ports?${newQuery.toString}`
    })

    if (portzone) {
      commit('setSettingPorts', portzone.data)
    }

    commit('unsetLoading')
  },
  toUploadPorts: async function ({ commit }, data) {
    commit('setLoading', 'menyimpan data pelabuhan')

    await this.dispatch('authenticatedApi', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/ports`,
      data
    })

    commit('unsetLoading')
  }
}

const mutations = {
  setGeoWPP: (state, geoWPP) => state.geoWPP = geoWPP,
  setGeoPortzone: (state, geoPortzone) => state.geoPortzone = geoPortzone,
  setSettingPorts: (state, data) => {
    state.settingPortsDefault = data.ports
    state.settingPortsActive = data.setting || {}
    state.settingPortsEnable = false

    for (var si in state.settingPortsActive) {
      state.settingPortsEnable = true

      break
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
